

const vies_regex = {
    AT: /^ATU\d{8}$/,
    BE: /^BE0\d{9}$/,
    BG: /^BG\d{9,10}$/,
    CY: /^CY\d{8}[A-Z]$/,
    CZ: /^CZ\d{8,10}$/,
    DE: /^DE\d{9}$/,
    DK: /^DK\d{8}$/,
    EE: /^EE\d{9}$/,
    EL: /^EL\d{9}$/,
    ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,
    FI: /^FI\d{8}$/,
    FR: /^FR[A-Z0-9]{2}\d{9}$/,
    HR: /^HR\d{11}$/,
    HU: /^HU\d{8}$/,
    IE: /^IE\d[A-Z0-9\+\*]\d{5}[A-Z]$/,
    IT: /^IT\d{11}$/,
    LT: /^LT(\d{9}|\d{12})$/,
    LU: /^LU\d{8}$/,
    LV: /^LV\d{11}$/,
    MT: /^MT\d{8}$/,
    NL: /^NL\d{9}B\d{2}$/,
    PL: /^PL\d{10}$/,
    PT: /^PT\d{9}$/,
    RO: /^RO\d{2,10}$/,
    SE: /^SE\d{12}$/,
    SI: /^SI\d{8}$/,
    SK: /^SK\d{10}$/,
    GB: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
    XI: /^XI\d{9}$/,
    NO: /^NO\d{9}$/,
    CH: /^CHE\d{9}(MWST|TVA|IVA)?$/,
    IS: /^IS\d{5,6}$/,
    LI: /^LI\d{6}$/,
    TR: /^TR\d{10}$/,
    RS: /^RS\d{9}$/,
    UA: /^UA\d{12}$/,
    MK: /^MK\d{13}$/,
    AL: /^AL[J-Z]\d{8}[A-Z]$/,
    MD: /^MD\d{8}$/,
    ME: /^ME\d{9}$/,
    BA: /^BA\d{8}$/
};

function setNativeValue(el, value) {
    if (!el) return;
    const proto = el instanceof window.HTMLTextAreaElement
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
    const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
    if (setter) setter.call(el, value);
    else el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
}

function normalizeTaxId(value) {
    let s = (value || '').toUpperCase().replace(/[\s\-]/g, '');
    if (/^\d{10}$/.test(s)) s = 'PL' + s; // sam polski NIP bez prefiksu
    return s;
}

function testTaxId(value) {
    const regex = vies_regex[value.substring(0, 2)];
    return regex ? regex.test(value) : false;
}

const init = (root) => {
    if (!root) return;

    const type = root.getElementById('custom#type_selected_on_registration');
    const tax_id = root.querySelector('#company_tax_id');

    if (type && type.parentElement) type.parentElement.style.display = 'none';
    if (tax_id) {
        const wrapper = tax_id.closest('div');
        if (wrapper) wrapper.style.display = 'none';
    }

      if (root.__b2bInit) return;

    const form = root.querySelector('form');
    const company_name = root.querySelector('#company_name');
    const email = root.querySelector('#email');
    const temp_tax_id = root.getElementById('custom#vat_id');
    const billing_recipient = root.querySelector('#billing_address_recipient');
    const billing_fname = root.querySelector('#billing_address_first_name');
    const billing_lname = root.querySelector('#billing_address_last_name');

    if (!form || !temp_tax_id || !tax_id) return;
    root.__b2bInit = true;

    const validateTaxId = () => {
        const normalized = normalizeTaxId(temp_tax_id.value);
        if (normalized !== temp_tax_id.value) setNativeValue(temp_tax_id, normalized);

        let tax_id_error = form.querySelector('.tax-id-error');

        if (normalized.length === 0) {
            setNativeValue(tax_id, '');
            if (tax_id_error) tax_id_error.remove();
            return false;
        }

        if (testTaxId(normalized)) {
            setNativeValue(tax_id, normalized);
            if (tax_id_error) tax_id_error.remove();
            return true;
        }

        setNativeValue(tax_id, '');
        if (!tax_id_error) {
            const el = document.createElement('output');
            el.setAttribute('role', 'alert');
            el.classList.add('_formError_1mxsl_21');
            el.classList.add('tax-id-error');
            temp_tax_id.closest('div').after(el);
            tax_id_error = form.querySelector('.tax-id-error');
        }
        tax_id_error.innerText = window.form_errors.vat_id;
        return false;
    };

    temp_tax_id.addEventListener('change', validateTaxId);
    form.addEventListener('submit', validateTaxId);

    setNativeValue(email, window.customer.email);
    setNativeValue(billing_fname, window.customer.fname);
    setNativeValue(billing_lname, window.customer.lname);
    setNativeValue(type, window.customer.type);

    if (billing_recipient && company_name) {
        company_name.addEventListener('change', () => {
            setNativeValue(billing_recipient, company_name.value);
        });
    }

    const style = document.createElement('style');
    style.innerText = `:host{ --inline-container-max-width: 100%; } legend { font-weight: 700 !important; padding-top: 1em !important; }`;
    root.appendChild(style);
};

const callback = (mutationList) => {
    for (const mutation of mutationList) {
        if (mutation.type !== 'childList') continue;
        const target = mutation.target;
        if (target && target.querySelector && target.querySelector('#app-embed')) {
            init(target.querySelector('#app-embed').shadowRoot);
        }
    }
};

const formRoot = document.querySelector('[data-form-root]');
if (formRoot) {
    new MutationObserver(callback).observe(formRoot, { childList: true, subtree: true });

    const block = formRoot.closest('.shopify-block');
    if (block) block.style.width = '100%';

    const embed = formRoot.querySelector('#app-embed');
    if (embed && embed.shadowRoot) init(embed.shadowRoot);
}
